<template>
  <v-row>
    <v-col class="wrapper-pay">
      <template>
        <span class="title-pay sucsess">
          УСПЕШНО ОТПРАВЛЕНО
        </span><br /> 
        <span class="text-pay">
          Отмена приказа успешно отправлена на email судьи
        </span><br /> 
      </template>
      <router-link to="/">
        <button class="red-button">
          Вернуться на главную
        </button>
      </router-link>
    </v-col>
  </v-row>
</template>

<script>

export default {
  data: () => ({
  }),
  methods: {

  },
  created() {
  },

};
</script>


<style scoped>
  .wrapper-pay{
      height: calc(100vh - 141px);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
  }
  .title-pay{
    font-family: 'Helvetica';
    font-style: normal;
    font-weight: 600;
    font-size: 36px;
    line-height: 36px;
    
  }
  .sucsess{
    color: green;
  }
  .error{
    color: red;
  }
  .text-pay{
    font-family: 'Helvetica';
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 131.5%;
    
    color: #000000;
  }
</style>


// WEBPACK FOOTER //
// send.vue?8347b6f2